let lang2d = {
    entity: {
        zh: '实体',
        en: 'Entity'
    },
    relation: {
        zh: '关系',
        en: 'Relation'
    },
    business: {
        zh: '活跃商家',
        en: 'Merchants'
    },
    totalNumber: {
        zh: '数据总量',
        en: 'Graph Data'
    },
    query: {
        zh: '用户搜索',
        en: 'Query'
    },
    result: {
        zh: '服务商家',
        en: 'Result'
    },
    searchPlaceholder: {
        zh: '请输入商店进行查询',
        en: 'Search for restaurants'
    },
    searchEmpty: {
        zh: '请输入内容',
        en: 'Please enter content'
    },
    commentCount: {
        zh: '评论数',
        en: 'Reviews',
    },
    taste: {
        zh: '口味',
        en: 'Taste',
    },
    environment: {
        zh: '环境',
        en: 'Environment'
    },
    service: {
        zh: '服务',
        en: 'Service'
    },
    recommendReason: {
        zh: '推荐理由',
        en: 'What\'s cool',
    },
    emotionEvaluate: {
        zh: '情感评价',
        en: 'Sentiment DIST'
    },
    like: {
        zh: '喜欢',
        en: 'Like'
    },
    neutral: {
        zh: '中性',
        en: 'Neutral'
    },
    dislike: {
        zh: '讨厌',
        en: 'Dislike'
    },
    emotionAnalyze: {
        zh: '情感曲线',
        en: 'Sentiment Trend',
    },
    commentCount2: {
        zh: '评价数量',
        en: 'Reviews',
    },
    sentimentAnalysis: {
        zh: '细粒度情感分析',
        en: 'Sentiment Analysis',
    },
    samePoi: {
        zh: '相似餐厅',
        en: 'Similar Restaurants',
    }
};
let getLang2d = (lang = window.$lang) => {
    let obj = {};
    for (let key in lang2d) {
        obj[key] = lang2d[key][lang];
    }
    return obj;
};

let lang2dObj = getLang2d($qsObj.lang || window.$lang);
export default lang2dObj;
